<div class="environment-sash">
  <span class="beta-btn">Beta</span>
  <span>
    This is a new
    <a [href]="ExternalUrl.AlbertaCa" target="_blank">Alberta Government</a>
    service. &nbsp;
  </span>
</div>
